import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Header from "../../components/Header";
import { livetools } from "../../Constants/livetools";
import Select from "react-select";
import { getallLandingOptions } from "../../Utils/utils";
import RadioItem from "../../components/RadioItem";
import Firebase from "../../firebasehelper";
import AddArticleModal from "../Articles/components/AddArticleModal";
import EditArticleModal from "../Articles/components/EditArticleModal";
import "./index.css";

const BespokeLiveTools = () => {
  const history = useHistory();
  const location = useLocation();
  const [brand_data, setBrandData] = useState({});
  const [communityLanding, setCommunityLanding] = useState("");
  const [allLandingOptions, setAllLandingOptions] = useState([]);
  const [customSelectStyles, setCustomSelectStyles] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [menuToAddArticle, setMenuToAddArticle] = useState();
  const [articleToEdit, setArticleToEdit] = useState();
  const editArticleBtnRef = useRef();

  useEffect(() => {
    if (!location.state) history.push("/");
    else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          const { communityLanding, ...rest } = brand_data;
          setBrandData(rest);
          const allOptions = getallLandingOptions(brand_data.name);
          setAllLandingOptions(allOptions);
          setCommunityLanding(
            communityLanding
              ? communityLanding
              : { label: "Explore", value: "explore" }
          );

          // Custom styles for the options in the dropdown
          setCustomSelectStyles({
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? brand_data.hex
                  ? brand_data.hex
                  : "#faff87"
                : "",
              fontWeight: state.isSelected ? 600 : 400,
              color: state.isSelected
                ? brand_data.white
                  ? "white"
                  : "black"
                : "black",
              "&:hover": {
                backgroundColor: state.isSelected
                  ? brand_data.hex
                    ? brand_data.hex
                    : "#faff87"
                  : "#fafafa",
                color: state.isSelected
                  ? brand_data.white
                    ? "white"
                    : "black"
                  : "black",
              },
            }),
          });
        }
        setLoading(false);
      });
    }
  }, [location]);

  /* starting of handler part */
  const handleYes = (menu) => async () => {
    const permissions = brand_data.permissions || {};
    await Firebase.updateBrandDataById(brand, {
      permissions: { ...permissions, [menu]: true },
    });
  };

  const handleNo = (menu) => async () => {
    const permissions = brand_data.permissions || {};
    await Firebase.updateBrandDataById(brand, {
      permissions: { ...permissions, [menu]: false },
    });
  };

  const onSelectLanding = async (newLanding) => {
    try {
      const { brand: brandId } = location.state;

      const newLandingObj = {
        label: newLanding.label,
        value: newLanding.value,
      };

      await Firebase.updateBrandDataById(brandId, {
        communityLanding: newLandingObj,
      });

      setCommunityLanding(newLanding);
    } catch (err) {
      console.log("onSelectLanding error", err);
    }
  };

  /* ending of handler part */
  const addArticle = async (article) => {
    article.time = new Date().getTime();
    const articleId = await Firebase.addBespokeArticle(
      article,
      brand_data.name
    );
    const bespokeArticles = brand_data.bespokeArticles || {};
    Firebase.updateBrandDataById(brand, {
      bespokeArticles: { ...bespokeArticles, [menuToAddArticle]: articleId },
    });
  };
  const updateArticle = async (article) => {
    article.time = new Date().getTime();
    await Firebase.updateBespokeArticle(brand_data.name, article.id, article);
  };
  const formatSubTabTitle = (tool) => {
    return tool.name === "shop"
      ? `${brand_data.name}'s Marketplace`
      : tool.title;
  };

  const renderMenus = () => {
    return Object.keys(livetools).map((tabs) => {
      const { displayname } = livetools[tabs];
      if (tabs === "supportTabs" && !brand_data.is_ecochat_need) return null;
      return (
        <div>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <p className="tab-title">{displayname}</p>
            </Grid>
            <Grid item xs={3}>
              <p className="col-header">Activation</p>
            </Grid>
            <Grid item xs={3}>
              <p className="col-header">Article</p>
            </Grid>
            <Grid item xs={3}>
              <p className="col-header">Article status</p>
            </Grid>
          </Grid>
          {livetools[tabs]["tabs"].map((tool) =>
            tool.name === "hotTopic" &&
            brand_data.name === "Factory Quarter" ? null : (
              <Grid
                container
                spacing={3}
                style={{ alignItems: "center", marginBottom: "10px" }}
              >
                <Grid item xs={3}>
                  <div className="group-label">
                    <img
                      src={tool.img}
                      className="community-tab-icon"
                      alt={tool.name}
                    ></img>
                    {formatSubTabTitle(tool)}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <RadioItem
                    // menuName={tool.title}
                    checked={
                      brand_data.permissions
                        ? brand_data.permissions[tool.name]
                        : false
                    }
                    // icon={tool.img}
                    onYes={handleYes(tool.name)}
                    onNo={handleNo(tool.name)}
                    isDisabled={tool.name === "explore"}
                  />
                </Grid>
                <Grid item xs={3}>
                  {brand_data.bespokeArticles &&
                  brand_data.bespokeArticles[tool.name] ? (
                    <button
                      className="btn btn-white article-btn"
                      onClick={() => {
                        Firebase.getBespokeArticleById(
                          brand_data.name,
                          brand_data.bespokeArticles[tool.name]
                        ).then((article) => {
                          setArticleToEdit(article);
                          editArticleBtnRef.current.click();
                        });
                      }}
                    >
                      Edit
                    </button>
                  ) : (
                    <button
                      className="btn btn-orange article-btn"
                      data-toggle="modal"
                      data-target="#add_article_modal"
                      onClick={() => setMenuToAddArticle(tool.name)}
                    >
                      Add
                    </button>
                  )}
                </Grid>
                <Grid item xs={3}>
                  {brand_data.bespokeArticles &&
                  brand_data.bespokeArticles[tool.name] ? (
                    <span className="article-live">Live</span>
                  ) : (
                    <span className="article-pending">Pending</span>
                  )}
                </Grid>
              </Grid>
            )
          )}
        </div>
      );
    });
  };

  return loading ? (
    <main className="bespoke-live-tools__loading">
      <i className="fa fa-3x fa-sync fa-spin text-muted" />
    </main>
  ) : (
    <div id="page-container" className="bespoke-explore-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        <div className="bespoke-live-tools">
          <section className="bespoke-live-tools__top-container">
            <h1 className="bespoke-live-tools__header">
              Bespoke the homepage that users are taken to
            </h1>
            <div className="bespoke-live-tools__dropdown-container">
              <Select
                value={communityLanding}
                onChange={onSelectLanding}
                options={allLandingOptions}
                styles={customSelectStyles}
                isSearchable={false}
              />
            </div>
          </section>
          <div className="left-content">
            <h2>Community Apps</h2>
            {brand_data && renderMenus()}
          </div>
        </div>
      </main>
      <AddArticleModal onAdd={addArticle} brand={brand_data} />
      <EditArticleModal
        initial={articleToEdit}
        onUpdate={updateArticle}
        brand={brand_data}
      />
      <button
        style={{ display: "none" }}
        ref={editArticleBtnRef}
        data-toggle="modal"
        data-target="#edit_article_modal"
      />
    </div>
  );
};
export default BespokeLiveTools;



// WEBPACK FOOTER //
// ./src/screens/Bespoke/index.js